module.exports = __webpack_public_path__ + "fonts/c3qJ0BDG.woff";